/* eslint-disable */
// src/utils/navigateVisitDetailsHelper.js

// se encarga de construir la ruta y el state de navegación.
/* 
 * Helper para navegar al detalle de una recaudación (con/sin localId).
 * Encapsula el path exacto y evita repetir lógica de rutas en la UI.
 */

export function getVisitDetailsDestination(visitId, localId, local, row, returnTo) {
  if (!visitId || !localId) return null;
  const localPayload = local ?? (row ? {
    Id: localId,
    Name: row.LocalName,
    City: row.LocalCity,
    Address: row.LocalAddress,
    Person: { Name: row.OwnerName },
  } : undefined);
  return {
    pathname: `/local/${localId}/recaudaciones/${visitId}`,
    state: { localId, local: localPayload, returnTo },
  };
}

export function navigateVisitDetailsHelper(navigate, visitId, localId, local, row, returnTo) {
  const destination = getVisitDetailsDestination(visitId, localId, local, row, returnTo);
  if (!destination) return;
  navigate(destination.pathname, { state: destination.state });
}
